<style lang="scss" scoped>
/* 步骤条 */
div.steps-wrap {
  min-height: 120px;
  height: auto;
  background: #fff;
  margin-bottom: 20px;
  padding: 12px 20px;
  margin-top: 310px;
}
.steps-wrap ul {
  width: 100%;
  display: table;
}
.steps-wrap ul li {
  position: relative;
  padding: 0px 0px 30px 0px;
  border-bottom: 2px solid #ccc;
  color: 1px solid #e5e5e5;
  font-size: 16px;
  box-sizing: border-box;
  display: table-cell;
}
.steps-wrap ul .li-more {
  position: relative;
  padding: 0px 0px 30px 0px;
  border-bottom: none;
  color: 1px solid #e5e5e5;
  font-size: 16px;
  box-sizing: border-box;
  display: table-cell;
}
// .steps-wrap ul .li-more:after{
//   border: none !important;
// }
.steps-wrap ul li.cur:after {
  //   border-color: #60C6D0;
  color: #60c6d0;
}
.steps-wrap ul li:after {
  position: absolute;
  bottom: -7px;
  left: 2%;
  margin-left: -7px;
  content: "";
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #de6f6f;
  box-sizing: border-box;
}
.steps-wrap ul li.cur:after {
  border: 1px solid #8ede8e;
  box-sizing: border-box;
}
.steps-wrap ul span {
  position: relative;
}
.steps-wrap ul .even span {
  top: 80px;
}
.steps-wrap ul li span {
  position: absolute;
}
span.even {
  top: -280px;
}
span.odd {
  top: 50px;
}

.close-btn {
  float: right;
  margin-right: 20px;
}

/deep/.show-img-modal {
  .ivu-modal-header {
    border: none;
  }
  .ivu-modal-body {
    display: flex;
    justify-content: center;
    .showImg {
      width: 200px;
      height: 300px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .ivu-modal-footer {
    border: none;
  }
}
/deep/ .show-table {
  .ivu-modal-body {
    padding-top: 15px;
    .show-table-header {
      border-left: 2px solid #90caf5;
      margin-left: 15px;
      padding-left: 10px;
      .table-header-desc {
        font-size: 18px;
        color: #90caf5;
      }
      /deep/ .close-btn {
        width: 55px;
        padding: 0;
        background: #2296eb;
        line-height: 24px;
        height: 27px;
        font-size: 16px;
        // color: #fff !important;
        color: #fff;
      }
    }
  }
  .ivu-modal-footer {
    border: none;
  }
}
.no-results {
  text-align: center;
  margin-top: 100px;
}
.loading{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%;
  padding-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,.3);
  img{
    width: 200px;
  }
}
</style>
<template>
  <div>
    <div class="no-results" v-if="!resultOnOff">未查询到该设备的巡检记录</div>
    <div class="loading" v-show="loading_status">
        <!-- 加载动画 -->
        <div class="loading_box" v-show="!dataTable.list.length">
            <img :src="tableLoad" />
        </div>
        <div class="more_data_box" v-show="dataTable.list.length">
            <img :src="tableMore" />
        </div>
    </div>
    <div class="steps-wrap" v-if="resultOnOff">
      <ul>
        <li
          v-for="(item,index) in newData"
          :key="index"
          :class="{'cur': item.checkResult === '正常' , 'li-more': index == 8}"
        >
          <!-- <span v-if="index%2 == 0" class="even">{{item.patrolName}}</span> -->
          <span v-if="index < 8 && index%2 == 0" class="even">
            <div style="width:150px;height:200px;margin-top: 10px"><img style="width:100%;height:100%" :src="item.filePath" alt=""></div>
            <div style="margin-top:10px;">{{timestampToTime(item.patrolTime)}}</div>
            <div>{{item.deviceName}}</div>
            <div>{{item.patrolName}}</div>
          </span>
          <span  v-if="index < 8 && index%2 != 0" class="odd">
            <div>{{timestampToTime(item.patrolTime)}}</div>
            <div>{{item.deviceName}}</div>
            <div style="margin-bottom:10px">{{item.patrolName}}</div>
            <div style="width:150px;height:200px;"><img style="width:100%;height:100%" :src="item.filePath" alt=""></div>
          </span>
          <span  v-if="index == 8">
            <a href="javascript:;" @click="openMore">查看更多</a>
          </span>
        </li>
      </ul>
    </div>

    <Modal
        v-model="modal1"
        :closable="false"
        :footer-hiddle="true"
        width="1000"
        class-name="show-table"
    >
        <div class="show-table-header">
          <span class="table-header-desc">巡检项</span>
          <Button class="close-btn" type="primary" @click="closeModal">返回</Button>
        </div>
        <private-table style="padding:0 15px" class="m-t-20"
          :columnsList="tableColumns"
          :dataTable="dataTable"
          @getPageData="getPageData"
          @sizeChange="sizeChange"
        >
        </private-table>
         <div slot="footer">
        </div>
    </Modal>

    <Modal
        v-model="modal2"
        class-name="show-img-modal"
    >
        <div slot="header" class="showImg-header"></div>
        <div class="showImg">
          <img :src="showImg" alt="">
        </div>
        <div style="border:none" slot="footer">
        </div>
    </Modal>
  </div>
</template>
<script>
import tableLoad from '@/assets/img/animation.gif';
import tableMore from '@/assets/img/animation.gif';
export default {
  props: ["deviceId"],
  name: "picture-record",
  data() {
    return {
      loading_status: false,
      tableLoad,
      tableMore,
      showImg: "",
      modal2: false,
      modal1: false,
      currentIndex: 1,
      resultOnOff: false,
      newData: [],
      data: [],
      dataTable: {},
      tableColumns: [
        { title: "巡检任务名称", key: "deviceName" },
        {
          title: "巡检时间",
          key: "patrolTime",
          render: (h, params) => {
            let arr = [
              h(
                "span",
                {},
                `${this.timestampToTime(
                  this.dataTable.list[params.index].patrolTime
                )}`
              )
            ];
            return h("div", arr);
          }
        },
        { title: "巡检人", key: "patrolName" },
        {
          title: "图片",
          key: "filePath",
          render: (h, params) => {
            let arr = [
              h("a", {}, [
                h(
                  "span",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    class: ["colorPrimary", "font14"],
                    style: {
                      marginRight: "10px",
                      verticalAlign: "middle"
                    },
                    on: {
                      click: () => {
                        this.showPicture(params.row.filePath);
                      }
                    }
                  },
                  "查看"
                )
              ])
            ];
            return h("div", arr);
          }
        }
      ],
      page: {
        totalCount: 0,
        pageSize: 10,
        currentPage: 1
      }
    };
  },
  mounted() {
   this.getData();
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      // console.log(to, '新')
      this.getData();
    }
  },
  methods: {
    getData() {
        this.resultOnOff = false;
        this.loading_status = true;
        let url='mcbw/patrol_records/picture';
        var data = {
            type: 'get',
            url: url,
            obj: {
                deviceId:this.deviceId,
                pageSize:this.page.pageSize,
                currentPage:this.page.currentPage,
            }
        };
        this.$Axios(data).then((res) => {
            this.loading_status = false;
            if (res.data.success) {
                if (res) {
                    this.data = res.data;
                    this.page.totalCount = res.totalCount;
                    this.dataTable = {
                        list: this.data,
                        page: this.page
                    };
                    if (this.page.currentPage == 1) {
                        if (this.data.length > 8) {
                            this.newData = this.data.slice(0, 9);
                        } else {
                            this.newData = this.data;
                            if (this.newData.length == 0) {
                                this.resultOnOff = false;
                            } else {
                                this.resultOnOff = true;
                            }
                        }
                    }
                }
            }
        });
    },
    openMore() {
      this.modal1 = true;
    },
    closeModal() {
      this.modal1 = false;
    },
    showPicture(img) {
      // 点击查看，显示图片
      this.modal2 = true;
      this.showImg = img;
    },
    getPageData(val) {
      // 分页页数
      this.page.currentPage = val;
      this.getData();
    },
    sizeChange(val) {
      // 每页条数
      this.page.pageSize = val;
      this.getData();
    },
    timestampToTime(timestamp) {
      // 转换时间戳
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/riskRecord/picture-record.vue